// extracted by mini-css-extract-plugin
export default {"field":"FloatingAuthInput_field__Y4A4c","required":"FloatingAuthInput_required__MEXX0"};